import { StylesProps } from 'types/common';

export const styles: StylesProps = {
  switchGridItem: {
    '&&&': { pt: 0 },
  },
};
